import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Rejoindre() {
 const { locale } = useLanguage();
 const l = (fr, en, pt) => locale === "en" ? en : locale === "pt" ? pt : fr;

 const ROLES = [
 {
 label: l("Distributeurs", "Distributors", "Distribuidores"),
 body: l(
 "Importateurs, épiceries fines, concept stores, pharmacies indépendantes. Rejoignez le réseau de distribution des Maisons NANDA SÁ.",
 "Importers, fine-food grocers, concept stores, independent pharmacies. Join the distribution network of the NANDA SÁ Houses.",
 "Importadores, mercearias finas, concept stores, farmácias independentes. Junte-se à rede de distribuição das Casas NANDA SÁ."
 ),
 },
 {
 label: l("Investisseurs", "Investors", "Investidores"),
 body: l(
 "Family offices, fonds à impact, business angels. Découvrez nos opportunités d'investissement structurées et long terme.",
 "Family offices, impact funds, business angels. Discover our structured, long-term investment opportunities.",
 "Family offices, fundos de impacto, business angels. Descubra as nossas oportunidades de investimento estruturadas e a longo prazo."
 ),
 },
 {
 label: l("Producteurs", "Producers", "Produtores"),
 body: l(
 "Coopératives, artisans, exploitations. Rejoignez nos filières et bénéficiez d'un accompagnement durable.",
 "Cooperatives, artisans, farms. Join our supply chains and benefit from lasting support.",
 "Cooperativas, artesãos, explorações. Junte-se às nossas fileiras e beneficie de um acompanhamento duradouro."
 ),
 },
 {
 label: l("Talents", "Talents", "Talentos"),
 body: l(
 "Profils techniques, commerciaux, créatifs. Notre Groupe recrute en continu entre la Guinée-Bissau.",
 "Technical, commercial and creative profiles. Our Group is hiring continuously between Guinea-Bissau.",
 "Perfis técnicos, comerciais, criativos. O nosso Grupo recruta continuamente entre a Guiné-Bissau."
 ),
 },
 ];

 return (
 <div data-testid="page-rejoindre">
 <section className="border-b border-nanda-line">
 <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pt-24 md:pt-40 pb-16 md:pb-24 grid grid-cols-1 md:grid-cols-12 gap-10">
 <FadeUp className="md:col-span-4">
 <div className="label-overline text-nanda-muted">{l("Nous rejoindre", "Join us", "Junte-se a nós")}</div>
 </FadeUp>
 <FadeUp delay={0.1} className="md:col-span-8">
 <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-balance leading-[1.0]">{l("Construire ensemble.", "Building together.", "Construir juntos.")}</h1>
 <p className="mt-10 max-w-2xl text-nanda-inkSoft text-base md:text-lg leading-relaxed">
 {l(
 "Quatre manières de rejoindre l'aventure NANDA SÁ. Choisissez la vôtre.",
 "Four ways to join the NANDA SÁ adventure. Choose yours.",
 "Quatro formas de se juntar à aventura NANDA SÁ. Escolha a sua."
 )}
 </p>
 </FadeUp>
 </div>
 </section>

 <section className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-16 md:py-24">
 <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-px bg-nanda-line border border-nanda-line">
 {ROLES.map((r, i) => (
 <StaggerItem key={i} className="bg-nanda-bg p-10 md:p-14" data-testid={`rejoindre-${i}`}>
 <div className="label-overline text-nanda-muted">0{i + 1}</div>
 <h2 className="font-serif text-4xl md:text-5xl mt-5 leading-tight">{r.label}</h2>
 <p className="mt-6 max-w-md text-nanda-inkSoft text-base leading-relaxed">{r.body}</p>
 <Link to={`/contact?subject=${encodeURIComponent(r.label)}`} className="mt-10 inline-flex items-center gap-3 label-overline border-b border-nanda-ink pb-1 hover:gap-5 transition-all duration-500">
 {l("Démarrer un échange", "Start a conversation", "Iniciar uma conversa")} <ArrowUpRight size={14} strokeWidth={1.5} />
 </Link>
 </StaggerItem>
 ))}
 </Stagger>
 </section>
 </div>
 );
}
